import { Updater } from 'widgets-for-react'
import {
  PaginationState,
  initialPaginationState,
} from '../../pagination/paginationState'
import {
  BlogTeasersState,
  initialBlogTeasersState,
} from '../blogTeasers/blogTeasersState'
import { getBlogTeasers, getBlogsCount } from './blogOverviewApi'
import { blogsPerPage } from './blogOverviewWidget'

export type BlogOverviewState = {
  blogTeasersState: BlogTeasersState
  paginationState: PaginationState
}

export const initialBlogOverviewState = (page: number): BlogOverviewState => ({
  blogTeasersState: initialBlogTeasersState(() =>
    getBlogTeasers(page, blogsPerPage)
  ),
  paginationState: initialPaginationState(getBlogsCount),
})

export const blogOverviewStateUpdaters = {
  updateBlogTeasersState:
    (update: Updater<BlogTeasersState>) =>
    (currentState: BlogOverviewState): BlogOverviewState => ({
      ...currentState,
      blogTeasersState: update(currentState.blogTeasersState),
    }),
  updatePaginationState:
    (update: Updater<PaginationState>) =>
    (currentState: BlogOverviewState): BlogOverviewState => ({
      ...currentState,
      paginationState: update(currentState.paginationState),
    }),
}
